import * as React from 'react'

import { config } from '../../../../common/config'
import { ISeoItem } from '../../../../typings/seoMetadata'
import Button from '../../../components/button'
import SectionDescription from '../sectionDescription'

import * as styles from './communitySection.module.css'

interface IProps {
  metadata: ISeoItem
}

const CommunitySection = ({ metadata }: IProps) => {
  return (
    <div data-test-selector="communitySection">
      <SectionDescription metadata={metadata} HTag="h6" />
      <div className={styles.buttonSection}>
        <Button primary href="https://community.envato.com/">
          Visit Our Forums
        </Button>
      </div>
      <div>
        <img
          alt="vist our forums"
          src={`${config.assets.PUBLIC_PATH}/images/home-page/community.png`}
          className={styles.img}
        />
      </div>
    </div>
  )
}

export default CommunitySection



// WEBPACK FOOTER //
// ./client/pages/home/communitySection/communitySection.tsx